// @ts-nocheck
import config from '@/config';
import actions from './actions';

const DEFAULT_ORDER_BY = config.FILTER_DEFAULTS.orderBy;
const DEFAULT_ORDER = config.FILTER_DEFAULTS.order;
export const DEFAULT_FEATURE_GROUP = config.FILTER_DEFAULTS.featureGroup;

export const filterObj = (options) => ({
  key: options.key,
  type: options.type || null,
  value: options.value || null,
  hidden: options.hidden || false,
  default: options.default || null,
});

export const defaults = {
  mode: filterObj({
    key: 'mode',
    value: config.SEARCH_MODES.SALE,
    type: String,
    default: config.SEARCH_MODES.SALE,
    hidden: true,
  }),
  featureGroup: filterObj({
    key: 'featureGroup',
    value: DEFAULT_FEATURE_GROUP,
    type: String,
    default: DEFAULT_FEATURE_GROUP,
    hidden: true,
  }),
  orderBy: filterObj({
    key: 'orderBy',
    value: DEFAULT_ORDER_BY,
    default: DEFAULT_ORDER_BY,
    type: String,
  }),
  order: filterObj({ key: 'order', value: DEFAULT_ORDER, default: DEFAULT_ORDER, type: String }),
  numberOfRooms: filterObj({ key: 'numberOfRooms', default: [], type: Array }),
  condition: filterObj({ key: 'condition', default: [], type: Array }),
  feature: filterObj({ key: 'feature', default: [], type: Array }),
  type: filterObj({ key: 'type', default: [], type: Array }),
  cityId: filterObj({ key: 'cityId', default: [], type: Array }),
  countyId: filterObj({ key: 'countyId', default: [], type: Array }),
  districtId: filterObj({ key: 'districtId', default: [], type: Array }),
  streetId: filterObj({ key: 'streetId', default: [], type: Array }),
  regionId: filterObj({ key: 'regionId', default: [], type: Array }),
  postalCode: filterObj({ key: 'postalCode', default: [], type: Array }),
};

const state = {
  filters: {
    // NOTE: keys are query parameters that need to match API
    mode: defaults.mode,
    featureGroup: defaults.featureGroup,
    orderBy: defaults.orderBy,
    order: defaults.order,
    numberOfRooms: defaults.numberOfRooms,
    condition: defaults.condition,
    type: defaults.type,
    cityId: defaults.cityId,
    countyId: defaults.countyId,
    districtId: defaults.districtId,
    streetId: defaults.streetId,
    regionId: defaults.regionId,
    postalCode: defaults.postalCode,
    feature: defaults.feature,
    ...config.FILTER_KEYS.reduce((map, key) => {
      map[key] = filterObj({ key, value: null });
      return map;
    }, {}),
  },
  counties: [],
  cities: [],
  districts: [],
  streets: [],
  regions: [],
  agent: null,
  waitForLocationLookup: false,
};

const mutations = {};

const getters = {
  getFilterValue: (state) => (key) => {
    if (state.filters[key]) {
      return state.filters[key].value ? state.filters[key].value : state.filters[key].default;
    }
    return null;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
